
export const isWithinLast8Hours = (dateArray: unknown): boolean | undefined => {
  let d: any[];
  if (!Array.isArray(dateArray)) {
    d = [dateArray];
  } else {
    d = dateArray;
  }

  const now = new Date();
  const eightHoursAgo = new Date(now.getTime() - 8 * 60 * 60 * 1000);

  for (var dateElement of d) {
    if (!(dateElement instanceof Date)) {
      console.log(`Attempting to convert ${dateElement} to date`);
      const date = new Date(dateElement);
      if (isNaN(date.getTime())) {
        console.error(`Invalid date string: ${dateElement}`);
        return undefined;
      }
    }
    // check if valid date
    if (isNaN(dateElement.getTime())) {
      console.error(`Invalid date string: ${dateElement}`);
      return undefined;
    }

    if (dateElement >= eightHoursAgo && dateElement <= now) {
      return true;
    }
  }

  return false;
};